import React from 'react';
import { Grid, GridProps } from '@material-ui/core';

type props =  GridProps & { margin?: number, extraMargin?: boolean }

export default function GridSelect(props: props) {
    return (
      <Grid {...props} style={{ margin: (props.margin ? props.margin : 10), marginRight: (props.extraMargin ? 10 : -10) }} />
    )
};
